export async function uploadFileToPresignedUrl({
  presignedUrl,
  file,
}: {
  presignedUrl: string;
  file: File;
}) {
  const response = await fetch(presignedUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to upload file: ${response.status} ${response.statusText}`);
  }
}
